import cookies from 'js-cookie';

export const SEARCH_COOKIE = 'ha-trip-prst';
export const LOCATION_COOKIE = 'ha-state-prst';

const DEFAULT_LOCATION_DATA = {
    destination: ''
};

const DEFAULT_SEARCH_DATA = {
    departureDate: null,
    arrivalDate: null,
    children: 0,
    adults: 0,
    petIncluded: false
};

function getDatesFromCookie(cookie) {
    if (!cookie) {
        return {
            arrivalDate: DEFAULT_SEARCH_DATA.arrivalDate,
            departureDate: DEFAULT_SEARCH_DATA.departureDate
        };
    }
    const {arrival, departure} = cookie;

    const arrivalMs = Date.parse(arrival);
    const departureMs = Date.parse(departure);

    const todayMs = Date.parse(new Date().toISOString().split('T')[0]);

    if (arrival && departure && arrivalMs >= todayMs && arrivalMs < departureMs) {
        return {
            arrivalDate: arrival,
            departureDate: departure
        };
    }

    return {
        arrivalDate: DEFAULT_SEARCH_DATA.arrivalDate,
        departureDate: DEFAULT_SEARCH_DATA.departureDate
    };
}

function getTypeOfGuestFromCookie(cookieGuests, defaultNumber) {
    const guests = parseInt(cookieGuests, 10);

    if (isNaN(guests)) {
        return defaultNumber;
    }

    return guests;
}

function getGuestsFromCookie(cookie) {
    if (!cookie) {
        return {
            adults: DEFAULT_SEARCH_DATA.adults,
            children: DEFAULT_SEARCH_DATA.children,
            petIncluded: DEFAULT_SEARCH_DATA.petIncluded
        };
    }

    const {
        children: defaultChildren,
        adults: defaultAdults,
        petIncluded: defaultPets
    } = DEFAULT_SEARCH_DATA;

    const {numberOfAdults, numberOfChildren, petIncluded} = cookie;

    const adults = getTypeOfGuestFromCookie(numberOfAdults, defaultAdults);

    if (adults === 0) {
        return {
            adults: defaultAdults,
            children: defaultChildren,
            petIncluded: defaultPets
        };
    }

    const children = getTypeOfGuestFromCookie(numberOfChildren, defaultChildren);

    return {
        adults,
        children,
        petIncluded: typeof petIncluded === 'string' ? petIncluded === 'true' : petIncluded
    };
}

function getLocationData(locationData) {
    if (!locationData || (locationData && locationData.lbsKeywords === null)) {
        return DEFAULT_LOCATION_DATA;
    }
    let {lbsKeywords = DEFAULT_LOCATION_DATA.destination} = locationData;

    return {
        destination: lbsKeywords.replace(/\+/g, ' ')
    };
}

export function getSearchValues() {
    const searchData = cookies.getJSON(SEARCH_COOKIE);
    const locationData = cookies.getJSON(LOCATION_COOKIE);

    if (!searchData && !locationData) {
        return {
            ...DEFAULT_SEARCH_DATA,
            ...DEFAULT_LOCATION_DATA
        };
    }

    return {
        ...getDatesFromCookie(searchData),
        ...getGuestsFromCookie(searchData),
        ...getLocationData(locationData)
    };
}

export function removeKeysFromCookieName(cookieName, keys) {
    const cookieObj = cookies.getJSON(cookieName);

    if (cookieObj) {
        keys.forEach((val) => delete cookieObj[val]);
        cookies.set(cookieName, cookieObj);
    }

    return cookieObj;
}

export function removeDatesFromTripCookie() {
    return removeKeysFromCookieName(LOCATION_COOKIE, ['previousDepartureDate', 'previousArrivalDate']);
}

export function removeDatesFromSearchCookie() {
    return removeKeysFromCookieName(SEARCH_COOKIE, ['departure', 'arrival']);
}
